import React, {useEffect, useState} from 'react';
import {useHistory} from "react-router-dom";
import {AgGridColumn} from '../../components/agGridColumn';
import {CButton} from '@coreui/react';
import CIcon from "@coreui/icons-react";
import Grid, {ListaMultiplaFilter} from '../../components/grid';
import {ActionProps} from '../../components/gridAction';
import enumDescription from "../../services/enumDescription";
import {getApi} from "../../apis/backendApis";
import {COR_SITUACAO, SituacaoProcesso, SituacaoProcessoList, dataBr, textoDesvio} from "./modelo";
import useMidia, {CELULAR} from "./useMidia";
import '../../scss/styles-processo.scss';

class FiltroSituacao extends ListaMultiplaFilter {
    getList(): enumDescription {
        return SituacaoProcessoList;
    }
}

const situacaoFormater = (params: any) => SituacaoProcessoList.getDescription(params.value);
const percentualFormater = (params: any) => (params.value === null || params.value === undefined ? '' : `${Math.round(params.value)}%`);
const dataFormater = (params: any) => dataBr(params.value);
const desvioFormater = (params: any) => (params.value === null || params.value === undefined ? '' : textoDesvio(params.value));

const ATIVAS = [SituacaoProcesso.ABERTO, SituacaoProcesso.EXECUTANDO, SituacaoProcesso.CONGELADO];

/** No celular a grade nao funciona bem: lista em cartoes, mais recentes primeiro. */
const Cartoes = () => {
    const history = useHistory();
    const [linhas, setLinhas] = useState<any[] | null>(null);
    const [todos, setTodos] = useState(false);

    useEffect(() => {
        getApi().get('processo/list', {params: {limit: 100, start: 0, sort: JSON.stringify([{col: 'id', sort: 'desc'}])}})
            .then(resposta => setLinhas(resposta.data.rows || []))
            .catch(() => setLinhas([]));
    }, []);

    const visiveis = (linhas || []).filter(linha => todos || ATIVAS.includes(linha.situacao));
    return (
        <div className="pr-cartoes">
            <div className="pr-cartoes-topo">
                <CButton color="primary" onClick={() => history.push('/processos/novo')}>
                    <CIcon name="cil-plus"/> Abrir processo
                </CButton>
                <label className="pr-marcar">
                    <input type="checkbox" checked={todos} onChange={e => setTodos(e.target.checked)}/> mostrar encerrados
                </label>
            </div>
            {linhas === null && <div className="pr-vazio">Carregando…</div>}
            {linhas !== null && visiveis.length === 0 && <div className="pr-vazio">Nenhum processo.</div>}
            {visiveis.map(linha => (
                <button type="button" key={linha.id} className="pr-cartao" onClick={() => history.push(`/processos/${linha.id}`)}>
                    <div className="pr-cartao-topo">
                        <strong>{linha['pessoaCliente/nome']}</strong>
                        <span className={`badge badge-${COR_SITUACAO[linha.situacao]}`}>{SituacaoProcessoList.getDescription(linha.situacao)}</span>
                    </div>
                    <div className="pr-cartao-sub">{linha['fluxo/codigo']} · {linha.etapaAtual || 'todas as etapas concluídas'}</div>
                    <div className="pr-barra"><span style={{width: `${linha.percentual}%`}}/></div>
                    <div className="pr-cartao-rodape">
                        <span>{Math.round(linha.percentual)}%</span>
                        <span>prev. {dataBr(linha.previsaoFim)} ({textoDesvio(linha.desvio)})</span>
                        {linha.pendenciasCliente > 0 && <span className="pr-chip cliente">{linha.pendenciasCliente} do cliente</span>}
                        {linha.atrasados > 0 && <span className="pr-chip atrasado">{linha.atrasados} atrasados</span>}
                    </div>
                </button>
            ))}
        </div>
    );
};

const ProcessoList = () => {
    const celular = useMidia(CELULAR);
    if (celular) {
        return <Cartoes/>;
    }

    const actions: Array<ActionProps> = [
        {
            route: 'processos/novo',
            color: 'success',
            type: 'normal',
            title: 'Abrir processo'
        },
        {
            route: 'processos/alterar',
            color: 'info',
            type: 'grid',
            title: 'Alterar'
        },
        {
            route: 'processos',
            color: 'primary',
            type: 'grid',
            title: 'Executar'
        },
    ];

    return (
        <Grid actions={actions} rota="processo/list">
            <AgGridColumn width={100} sort="desc" headerName="#" checkboxSelection field="id" sortable={true} filter={'agNumberColumnFilter'}></AgGridColumn>
            <AgGridColumn flex={2} minWidth={200} headerName="Cliente" field="pessoaCliente/nome" sortable={true} filter={true}></AgGridColumn>
            <AgGridColumn width={90} headerName="Fluxo" field="fluxo/codigo" sortable={true} filter={true}></AgGridColumn>
            <AgGridColumn width={150} headerName="Situação" field="situacao" sortable={true} filter={FiltroSituacao} valueFormatter={situacaoFormater}></AgGridColumn>
            <AgGridColumn width={80} headerName="%" field="percentual" sortable={true} filter={'agNumberColumnFilter'} valueFormatter={percentualFormater}></AgGridColumn>
            <AgGridColumn flex={1} minWidth={180} headerName="Etapa atual" field="etapaAtual" sortable={false}></AgGridColumn>
            <AgGridColumn width={110} headerName="Do cliente" field="pendenciasCliente" sortable={false} headerTooltip="Itens pendentes do cliente"></AgGridColumn>
            <AgGridColumn width={100} headerName="Atrasados" field="atrasados" sortable={false}></AgGridColumn>
            <AgGridColumn width={110} headerName="Início" field="dataInicio" sortable={true} valueFormatter={dataFormater}></AgGridColumn>
            <AgGridColumn width={110} headerName="Previsão" field="previsaoFim" sortable={true} valueFormatter={dataFormater}></AgGridColumn>
            <AgGridColumn width={100} headerName="Desvio" field="desvio" sortable={false} valueFormatter={desvioFormater}></AgGridColumn>
            <AgGridColumn width={150} headerName="Gestor" field="gestor/nome" sortable={true} filter={true}></AgGridColumn>
        </Grid>
    );
};

export default ProcessoList;
